module.exports = __webpack_public_path__ + "img/paymentOkIcon.ed19c00a.svg";